export const unsolvedPromise = async () => {
  return new Promise(() => undefined);
};
